import { useState } from 'react';
import Button from '../Button/Button';
import AlertModal from '../AlertModal/AlertModal';
import './TwoFactor.scss';

/**
 * 2º passo do login quando o utilizador já tem 2FA ativo — pede o código da app
 * autenticadora (ou um código de recuperação de uso único) e troca o `mfa_token` de
 * curta duração (5 min) pelo access_token definitivo em POST /auth/2fa/verify.
 */
export default function TwoFactorVerify({ mfaToken, axiosAuth, onVerified, onCancel }) {
  const [code, setCode] = useState('');
  const [useRecovery, setUseRecovery] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  async function handleSubmit(e) {
    e.preventDefault();
    if (loading || !code) return;
    setLoading(true);
    setError(null);
    try {
      const { data } = await axiosAuth.post('/auth/2fa/verify', {
        mfa_token: mfaToken,
        code,
      });
      onVerified(data.access_token);
    } catch (err) {
      setError(
        err.response?.status === 401
          ? 'Código inválido ou expirado.'
          : 'Ocorreu um erro. Tenta mais tarde.',
      );
      setCode('');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="two-factor-flow">
      {error && (
        <AlertModal
          variant="danger"
          title="Aviso"
          message={error}
          onClose={() => setError(null)}
        />
      )}
      <h3>Verificação em duas etapas</h3>
      <p className="two-factor-hint">
        {useRecovery
          ? 'Introduz um dos teus códigos de recuperação (uso único).'
          : 'Introduz o código de 6 dígitos da tua app autenticadora.'}
      </p>
      <form onSubmit={handleSubmit} className="two-factor-code-form">
        <input
          className="input"
          type="text"
          inputMode={useRecovery ? 'text' : 'numeric'}
          placeholder={useRecovery ? 'xxxx-xxxx' : 'Código de 6 dígitos'}
          maxLength={useRecovery ? 16 : 6}
          value={code}
          onChange={(e) =>
            setCode(
              useRecovery ? e.target.value.trim() : e.target.value.replace(/\D/g, ''),
            )
          }
          autoFocus
          required
          disabled={loading}
        />
        <div className="two-factor-actions">
          <Button type="submit" disabled={loading || !code}>
            Confirmar
          </Button>
          {onCancel && (
            <Button type="button" variant="secondary" onClick={onCancel}>
              Voltar
            </Button>
          )}
        </div>
      </form>
      <button
        type="button"
        className="two-factor-link"
        onClick={() => {
          setUseRecovery((v) => !v);
          setCode('');
        }}
      >
        {useRecovery
          ? 'Usar antes o código da app autenticadora'
          : 'Perdi o acesso à app — usar código de recuperação'}
      </button>
    </div>
  );
}
